import moment from 'moment-timezone';

export const formatDateWithMoment = (inputDate: string | Date, timeZone = 'UTC'): string | null => {
	try {
		const momentDate = moment.tz(inputDate, timeZone);

		if (!momentDate.isValid()) {
			throw new Error('Invalid date format');
		}

		return momentDate.format('DD MMM, YYYY');
	} catch (error) {
		console.error('Error formatting date:', (error as Error).message);
		return null;
	}
};

export const formatCurrency = (currencyCode: string, amount: number) =>
	new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: currencyCode
	}).format(amount);
